// ----------------------------------------------------------------------------
// Favicon switcher
// - Swaps the <link rel="icon"/apple-touch-icon> hrefs between the finance
//   and spiritual icon sets whenever the route's section changes.
// - public/index.html ships the finance set as the default (first paint,
//   before this runs); this only touches the DOM when the section flips.
// ----------------------------------------------------------------------------

const ICON_SETS = {
    finance: {
        ico: '/favicon-finance.ico',
        png32: '/favicon-finance-32.png',
        png192: '/favicon-finance-192.png',
        apple: '/apple-touch-icon-finance.png'
    },
    spiritual: {
        ico: '/favicon-spiritual.ico',
        png32: '/favicon-spiritual-32.png',
        png192: '/favicon-spiritual-192.png',
        apple: '/apple-touch-icon-spiritual.png'
    }
};

let lastSection = null;

function applyFaviconSet(section) {
    if (section === lastSection) return;
    lastSection = section;

    const set = ICON_SETS[section] || ICON_SETS.finance;
    const ico = document.getElementById('favicon-ico');
    const png32 = document.getElementById('favicon-32');
    const png192 = document.getElementById('favicon-192');
    const apple = document.getElementById('favicon-apple');

    if (ico) ico.href = set.ico;
    if (png32) png32.href = set.png32;
    if (png192) png192.href = set.png192;
    if (apple) apple.href = set.apple;
}

/** Installs an afterEach hook that swaps the favicon per route section. */
export function installFaviconSwitcher(router) {
    router.afterEach((to) => {
        applyFaviconSet(to.meta?.section || 'finance');
    });
}
